import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { IconText } from 'components/atoms';
import { Tooltip } from 'components/molecules'
import theme from 'services/theme.semantic';

/**
 * Global navigation item (for sub-webs)
 */
const NavItemGlobal = ({
  isActive,
  activeColor,
  onClick,
  title,
  titleShort,
  stretch,
}) => {
  const [isHover, setIsHover] = useState(isActive);
  const text = useMemo(() => (stretch ? title : titleShort), [
    stretch,
    title,
    titleShort,
  ]);

  // reset isHover to false when changing active
  useEffect(() => {
    setIsHover(false)
  }, [isActive])

  return (
    <Tooltip tooltip={title} placement="right-end" hideArrow>
      <Wrapper
        onMouseOver={() => setIsHover(true)}
        onFocus={() => setIsHover(true)}
        onBlur={() => setIsHover(false)}
        onMouseLeave={() => setIsHover(false)}
        onClick={onClick}
      >
        <IconText
          isActive={isActive || isHover}
          activeColor={activeColor}
          shouldInk
          stretch={stretch}
        >
          {text}
        </IconText>
      </Wrapper>
    </Tooltip>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
`;

NavItemGlobal.propTypes = {
  isActive: PropTypes.bool,
  activeColor: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  titleShort: PropTypes.string.isRequired,
  stretch: PropTypes.bool,
};

NavItemGlobal.defaultProps = {
  isActive: false,
  activeColor: theme.colors.primary,
  onClick: () => null,
  stretch: false,
};

export default NavItemGlobal;
